module.exports = __webpack_public_path__ + "assets/images/p4_f04c05a8afd7ec8f58addb4695c9c8eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/p4.png
// module id = 128
// module chunks = 0